import {Components, Fields} from '@exp1/front-utils'
import {permissionHooks} from 'hooks/permissions'
import {roleHooks} from 'hooks/roles'
import {serviceHooks} from 'hooks/services'
import {filter} from 'lodash'
import {Form} from 'react-final-form'
import {useNavigate} from 'react-router-dom'
import {itemsToOptions} from 'utils/findItem'

export const Create = () => {
  const navigate = useNavigate()
  const createMutation = roleHooks.useCreateMutation()
  const serviceListQuery = serviceHooks.useListQuery()
  const permissionListQuery = permissionHooks.useListQuery()

  const onSubmit = (values: any) => {
    createMutation.mutate(values, {
      onSuccess: (role) => navigate(`/roles/${role.id}/edit`),
    })
  }

  if (!serviceListQuery.data || !permissionListQuery.data) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <Components.Header.H5>Create role</Components.Header.H5>
      <Form
        keepDirtyOnReinitialize
        initialValues={{permissionIds: []}}
        onSubmit={onSubmit}
        render={({handleSubmit, values}) => {
          const serviceOptions = itemsToOptions(serviceListQuery.data)
          const permissionOptions = itemsToOptions(filter(permissionListQuery.data, {serviceId: values.serviceId}))
          return (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <Fields.InputField label="Name" name="name" expanded />
              <Fields.InputField label="Code" name="code" expanded />
              <Fields.SelectField label="Service" name="serviceId" options={serviceOptions} expanded />
              <Fields.MultiSelectField
                label="Permissions"
                name="permissionIds"
                options={permissionOptions}
                visibleNumber={permissionOptions.length}
                expanded
              />
              <Components.Button disabled={!values.name || !values.code || !values.serviceId} className="ml-auto">
                Create
              </Components.Button>
            </form>
          )
        }}
      />
    </div>
  )
}
